import type { ApiClient } from './client';

/** Операция ledger ID. Это не подтверждённая покупка и не партия Circle. */
export interface FinanceLedgerEntry {
  id: number;
  amount_tokens: string;
  direction: 'credit' | 'debit';
  canceled: boolean;
  timestamp_unix: number;
}

export interface FinanceOverview {
  balance: { legacy_tokens: string | null; circle: number | null };
  ledger: FinanceLedgerEntry[];
  next_before_id: number | null;
  purchases: unknown | null;
  subscription: unknown | null;
  capabilities: {
    legacy_balance: boolean;
    legacy_ledger: boolean;
    circle_balance: boolean;
    purchases: boolean;
    subscriptions: boolean;
  };
}

/** Чтение подтверждённого обзора. Курсор — id последней показанной операции. */
export const finance = (client: ApiClient) => ({
  overview: (beforeId?: number, signal?: AbortSignal) =>
    client.request<FinanceOverview>('/app/finance/overview', {
      query: { limit: 20, before_id: beforeId },
      signal,
    }),
});
